import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-guarded-input',
  templateUrl: './guarded-input.component.html',
  styleUrls: ['./guarded-input.component.scss']
})
/***
 * If `activated` is false a label is shown:
 * ```
 * <span fxFlex="100%">{{value}}</span>
 * ```
 *
 * Furthermore an icon is optionally accepted for the label and it should have the class 'icon':
 * ```
 * <app-guarded-input>
 *   <mat-icon class="icon">icon</mat-icon>
 *  </app-guarded-input>
 *  ```
 * would render:
 * ```
 * <mat-icon class="icon">icon</mat-icon> <span fxFlex="100%">{{value}}</span>
 * ```
 *
 * ---
 *
 * If `activated` is true the content is projected
 */
export class GuardedInputComponent implements OnInit {
  @Input() activated: boolean;
  @Input() value: string;

  constructor() { }

  ngOnInit(): void {
  }

}
